import { styled } from '../../utils/styled'
import Typography from '../Typography'
import { type LabelColor } from './types'
import { type Theme, type CSSObject } from '@mui/material/styles'

export const StyledLabelText = styled(Typography)({
  minHeight: '24px'
})

export const StyledLabelContainer = styled('div')<{ color: LabelColor }>(({ color, theme }): any => ({
  display: 'inline-flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  alignSelf: 'start', // prevents component from stretching...
  padding: '8px 16px',
  borderRadius: theme.borderRadius.medium,
  ...(['success', 'green'].includes(color) && {
    ...StyledGreenLabel(theme)
  }),
  ...(['warning', 'orange'].includes(color) && {
    ...StyledOrangeLabel(theme)
  }),
  ...(['info', 'blue'].includes(color) && {
    ...StyledBlueLabel(theme)
  }),
  ...(['error', 'red'].includes(color) && {
    ...StyledRedLabel(theme)
  })
}))

const StyledGreenLabel = (theme: Theme): CSSObject => ({
  background: theme.tokens.background.semantic.success.tonal.superSoft.default,
  color: theme.tokens.foreground.semantic.success.default
})

const StyledOrangeLabel = (theme: Theme): CSSObject => ({
  background: theme.tokens.background.semantic.warning.tonal.superSoft.default,
  color: theme.tokens.foreground.semantic.warning.default
})

const StyledBlueLabel = (theme: Theme): CSSObject => ({
  background: theme.tokens.background.semantic.info.tonal.superSoft.default,
  color: theme.tokens.foreground.semantic.info.default
})

const StyledRedLabel = (theme: Theme): CSSObject => ({
  background: theme.tokens.background.semantic.error.tonal.superSoft.default,
  color: theme.tokens.foreground.semantic.error.default
})
